import React, { Component } from "react";
import Select from "react-select";
import { ChevronDown } from "react-feather";
import { connect } from "react-redux";
import {
  getCOUNTRYMASTERAction,
  getSTATEMASTERAction,
  getCITYMASTERAction,
} from "store/masters";
import { setContactAction } from "store/userWalkthrough";
class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      AddressType: "1",
      //Permanent
      selectedCountryPermanent: "0", //api
      selectedStatePermanent: "0",
      selectedCityPermanent: "",
      PincodePermanent: "",
      Add1Permanent: "",
      Add2Permanent: "",
      selectedCountryPermanentValue: "",
      selectedStatePermanentValue: "",
      selectedCityPermanentValue: "", //show
      //present
      selectedCountryPresent: "1",
      selectedStatePresent: "0",
      selectedCityPresent: "",
      selectedCountryPresentValue: "",
      selectedStatePresentValue: "",
      selectedCityPresentValue: "",
      PincodePresent: "",
      Add1Present: "",
      Add2Present: "",
      sameasPermanent: false,
      isPresentVisible: true,
      Submited: false,
      show: false,
      OptionsCountry: [
        {
          label: "India",
          value: 1,
        },
      ],
      OptionsState: [],
      OptionsCity: [],
      OptionsPrsentCountry: [
        {
          label: "India",
          value: 1,
        },
      ],
      OptionsPrsentState: [],
      OptionsPrsentCity: [],
    };
  }

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   if (prevProps.CONTACTDETAILS !== this.props.CONTACTDETAILS) {
  //       this.prefillInfo()
  //   }
  // }
  async prefillInfo(from) {
    debugger;
    if (this.props.CONTACTDETAILS) {
      var permanentArray = this.props.CONTACTDETAILS.Data.filter(
        (item) => item.TypeID == 1
      );
      var presentArray = this.props.CONTACTDETAILS.Data.filter(
        (item) => item.TypeID == 2
      );
      if (!this.props.STATEMASTER) {
        await this.props.getSTATEMASTERAction(
          permanentArray.length > 0
            ? permanentArray[permanentArray.length - 1].CountryID
            : ""
        );
      }
      let cityPER =
        permanentArray.length > 0
          ? permanentArray[permanentArray.length - 1].StateID
          : "";
      let cityPRE =
        presentArray.length > 0
          ? presentArray[presentArray.length - 1].StateID
          : "";

      if (cityPER && from == 1) {
        await this.props.getCITYMASTERAction(
          permanentArray.length > 0
            ? permanentArray[permanentArray.length - 1].StateID
            : ""
        );
      } else if (cityPRE && from == 2) {
        await this.props.getCITYMASTERAction(
          presentArray.length > 0
            ? presentArray[presentArray.length - 1].StateID
            : ""
        );
      }

      this.setState({
        selectedCountryPermanent:
          permanentArray.length > 0
            ? permanentArray[permanentArray.length - 1].CountryID
            : "",
        selectedStatePermanent:
          permanentArray.length > 0
            ? permanentArray[permanentArray.length - 1].StateID
            : "",
        selectedCityPermanent:
          permanentArray.length > 0
            ? permanentArray[permanentArray.length - 1].City
            : "",
        PincodePermanent:
          permanentArray.length > 0
            ? permanentArray[permanentArray.length - 1].Pincode
            : "",
        Add1Permanent:
          permanentArray.length > 0
            ? permanentArray[permanentArray.length - 1].AddressLine1
            : "",
        Add2Permanent:
          permanentArray.length > 0
            ? permanentArray[permanentArray.length - 1].AddressLine2
            : "",
      });

      this.setState({
        selectedCountryPresent:
          presentArray.length > 0
            ? presentArray[presentArray.length - 1].CountryID
            : "",
        selectedStatePresent:
          presentArray.length > 0
            ? presentArray[presentArray.length - 1].StateID
            : "",
        selectedCityPresent:
          presentArray.length > 0
            ? presentArray[presentArray.length - 1].City
            : "",
        PincodePresent:
          presentArray.length > 0
            ? presentArray[presentArray.length - 1].Pincode
            : "",
        Add1Present:
          presentArray.length > 0
            ? presentArray[presentArray.length - 1].AddressLine1
            : "",
        Add2Present:
          presentArray.length > 0
            ? presentArray[presentArray.length - 1].AddressLine2
            : "",
      });
    }
  }
  async componentDidMount() {
    // setTimeout(async () =>
    // {
    await this.prefillInfo(1);
    await this.props.getCOUNTRYMASTERAction();
    await this.props.getSTATEMASTERAction(1);
    //  await this.handleChangeCountry(1)

    this.setState({
      Add1Permanent: this.props.PARSERESUME.Address1,
      Add2Permanent: this.props.PARSERESUME.Address2,
      Add1Present: this.props.PARSERESUME.Address1,
      Add2Present: this.props.PARSERESUME.Address2,
      PincodePermanent: this.props.PARSERESUME.PINNumber,
      PincodePresent: this.props.PARSERESUME.PINNumber,
      selectedCountryPresent: "1",
      // selectedStatePresent: "1",
      selectedCountryPermanent: "1",
      // selectedStatePermanent: "1",
    });

    // let optionsCountry = this.props.COUNTRYMASTER.Data.map((el) => ({
    //   label: "india",
    //   value: 1,
    // }));

    let optionsState = this.props.STATEMASTER.Data.map((el) => ({
      label: el.Title,
      value: el.Value,
    }));
    // this.setState({
    //   OptionsCountry: optionsCountry,
    //   OptionsPrsentCountry: optionsCountry,
    // });
    this.setState({ OptionsState: optionsState });
    //
    // this.parseResumeSet();

    // if (!parseInt(this.props.PARSERESUME.CountryID)) {
    //   await this.props.getSTATEMASTERAction(1);
    // }
    // },
    // 1000);
  }
  async handleChangeCountry(e) {
    // e.preventDefault();

    // console.log(e.target.value);
    debugger;
    this.setState({
      selectedCountryPermanent: e.value,
      selectedCountryPermanentValue: e,
    });
    await this.props.getSTATEMASTERAction(e.value);

    // var index = e.target.selectedIndex;
    // var optionElement = e.target.childNodes[index];
    // var optionviml = optionElement.getAttribute("data-viml");
    // var optionpass = optionElement.getAttribute("data-pass");
    // this.setState({ selectedviml: optionviml });
    // this.setState({ selectedpass: optionpass });
  }
  async handleChangeState(e) {
    // e.preventDefault();

    this.setState({
      selectedStatePermanent: e.value,
      selectedStatePermanentValue: e,
    });
    await this.props.getCITYMASTERAction(e.value);
    let optionsCity = this.props.CITYMASTER.Data.map((el) => ({
      label: el.Title,
      value: el.Value,
    }));
    this.setState({ OptionsCity: optionsCity });
  }
  async handleChangeCity(e) {
    // e.preventDefault();
    debugger;
    this.setState({
      selectedCityPermanent: e.value,
      selectedCityPermanentValue: e,
    });
  }

  //present
  async handleChangeCountryPresent(e) {
    debugger;
    this.setState({
      selectedCountryPresent: e.value,
      selectedCountryPresentValue: e,
    });
    await this.props.getSTATEMASTERAction(1);
    let optionsState = this.props.STATEMASTER.Data.map((el) => ({
      label: el.Title,
      value: el.Value,
    }));
    this.setState({ OptionsPrsentState: optionsState });
  }
  async handleChangeStatePresent(e) {
    // e.preventDefault();
    this.setState({
      selectedStatePresent: e.value,
      selectedStatePresentValue: e,
    });
    await this.props.getCITYMASTERAction(e.value);
    let optionsCity = this.props.CITYMASTER.Data.map((el) => ({
      label: el.Title,
      value: el.Value,
    }));
    this.setState({ OptionsPrsentCity: optionsCity });
  }
  async handleChangeCityPresent(e) {
    // e.preventDefault();
    this.setState({
      selectedCityPresent: e.value,
      selectedCityPresentValue: e,
    });
  }

  submitContactDetails = async (event) => {
    event.preventDefault();
    const {
      Add1Permanent,
      Add2Permanent,
      selectedCountryPermanent,
      selectedStatePermanent,
      selectedCityPermanent,
      PincodePermanent,
      Add1Present,
      selectedCountryPresent,
      Add2Present,
      selectedStatePresent,
      selectedCityPresent,
      PincodePresent,
      AddressType,
    } = this.state;
    if (!selectedCountryPermanent && AddressType == 1) {
      alert("Country is mandatory");
      return false;
    }
    if (!selectedStatePermanent && AddressType == 1) {
      alert("State is mandatory");
      return false;
    }
    if (!selectedCityPermanent && AddressType == 1) {
      alert("City is mandatory");
      return false;
    }
    if (!PincodePermanent && AddressType == 1) {
      alert("Pincode is mandatory");
      return false;
    }
    if (!Add1Permanent && AddressType == 1) {
      alert("First Address is mandatory");
      return false;
    }

    //
    if (!Add1Present && AddressType == 2) {
      alert("First Address is mandatory");
      return false;
    }
    if (!selectedCountryPresent && AddressType == 2) {
      alert("Country is mandatory");
      return false;
    }
    if (!selectedStatePresent && AddressType == 2) {
      alert("State is mandatory");
      return false;
    }
    if (!selectedCityPresent && AddressType == 2) {
      alert("City is mandatory");
      return false;
    }
    if (!PincodePresent && AddressType == 2) {
      alert("Pincode is mandatory");
      return false;
    }

    // let AddressLine1 = this.state.sameasPermanent == '' ? alert('Empty Address Line 1') : this.state.Add1Present;
    // let AddressLine2 = this.state.sameasPermanent == '' ? alert('Empty Address Line 2') : this.state.Add2Present;
    // let CountryID = this.state.sameasPermanent == '' ? alert('Empty Country') : this.state.selectedCountryPresent;
    // let StateID = this.state.sameasPermanent == '' ? alert('Empty State') : this.state.selectedStatePresent;
    // let City = this.state.sameasPermanent == '' ? alert('Empty City') : this.state.selectedCityPresent;
    // let Pincode = this.state.sameasPermanent == '' ? alert('Empty Pincode') : this.state.PincodePresent;
    var contactArray = {
      CandidateNo: this.props.Auth.HCID,
      Address: [
        {
          TypeID: 2,
          AddressLine1: this.state.sameasPermanent
            ? Add1Permanent
            : this.state.Add1Present,
          AddressLine2: this.state.sameasPermanent
            ? Add2Permanent
            : this.state.Add2Present,
          CountryID: this.state.sameasPermanent
            ? selectedCountryPermanent
            : this.state.selectedCountryPresent,
          StateID: this.state.sameasPermanent
            ? selectedStatePermanent
            : this.state.selectedStatePresent,
          City: this.state.sameasPermanent
            ? selectedCityPermanent
            : this.state.selectedCityPresent,
          Pincode: this.state.sameasPermanent
            ? PincodePermanent
            : this.state.PincodePresent,
          //"StayingFromMonth": this.presentFromMonth,
          //"StayingFromYear": this.presentFromYear
        },
        {
          TypeID: 1,
          AddressLine1: Add1Permanent,
          AddressLine2: Add2Permanent,
          CountryID: selectedCountryPermanent,
          StateID: selectedStatePermanent,
          City: selectedCityPermanent,
          Pincode: PincodePermanent,
          //"StayingFromMonth": this.permanentFromMonth,
          //"StayingFromYear": this.permanentFromYear
        },
      ],
    };
    let response = await this.props.setContactAction(contactArray);
    if (response.ResponseCode == 100) {
      alert(response.ResponseMessage);
      this.setState({ Submited: true });
    } else {
      alert(response.ResponseMessage);
    }
  };

  // async submitContactDetails() {

  //   var contactArray = {
  //     CandidateNo: this.props.Auth.HCID,

  //     Address: [
  //       {
  //         TypeID: 2,
  //         AddressLine1: this.state.sameasPermanent ? this.state.Add1Permanent : this.state.Add1Present,
  //         AddressLine2: this.state.sameasPermanent ? this.state.Add2Permanent : this.state.Add2Present,
  //         CountryID: this.state.sameasPermanent ? this.state.selectedCountryPermanent : this.state.selectedCountryPresent,
  //         StateID: this.state.sameasPermanent ? this.state.selectedStatePermanent : this.state.selectedStatePresent,
  //         City: this.state.sameasPermanent ? this.state.selectedCityPermanent : this.state.selectedCityPresent,
  //         Pincode: this.state.sameasPermanent ? this.state.PincodePermanent : this.state.PincodePresent,
  //         //"StayingFromMonth": this.presentFromMonth,
  //         //"StayingFromYear": this.presentFromYear
  //       },
  //       {
  //         TypeID: 1,
  //         AddressLine1: this.state.Add1Permanent,
  //         AddressLine2: this.state.Add2Permanent,
  //         CountryID: this.state.selectedCountryPermanent,
  //         StateID: this.state.selectedStatePermanent,
  //         City: this.state.selectedCityPermanent,
  //         Pincode: this.state.PincodePermanent,
  //         //"StayingFromMonth": this.permanentFromMonth,
  //         //"StayingFromYear": this.permanentFromYear
  //       },
  //     ],
  //   };

  //   if (contactArray.Address[0].TypeID === 2 && contactArray.Address[0].AddressLine1 === "") {
  //     alert("no address")

  //   } else {
  //     let response = await this.props.setContactAction(contactArray);

  //     console.log(response);
  //     if (response.ResponseCode == 100) {
  //       alert(response.ResponseMessage);
  //     } else {
  //       alert(response.ResponseMessage);
  //     }

  //   }
  //   // let response = await this.props.setContactAction(contactArray);
  //   // console.log(response);
  //   // if (response.ResponseCode == 100) {
  //   //   alert(response.ResponseMessage);
  //   // } else {
  //   //   alert(response.ResponseMessage);
  //   // }
  // }

  async setAddType(val) {
    await this.setState({ AddressType: val });
    await this.prefillInfo(val);
  }
  sameasPermanent() {}
  parseResumeSet() {
    this.setState({
      AddressLine1: this.props.PARSERESUME.Address1,
      AddressLine2: this.props.PARSERESUME.Address2,
      CountryID: this.props.PARSERESUME.CountryID,
      StateID: this.props.PARSERESUME.StateID,
      Pincode: this.props.PARSERESUME.PINNumber,
    });
  }
  render() {
    return (
      <card className="rounded-12px lg:w-full md:w-full  bg-white block mt-2">
        <div className="md:pb-4 lg:pb-4 pb-2">
          <div className="	relative">
            <div className="transform-tab cursor-pointer lg:mb-0 mb-4">
              {/* <div className="flex lg:justify-evenly md:justify-evenly lg:px-0 px-3 justify-between items-center bgFDF1E7 rounded-8px h-41px w-200px sm-w-full">
                <p className="text-black opacity-65 fsize14 font-semibold ">
                  Open Resume Tab
                </p>
                <ChevronDown className="text053C6D" />
              </div> */}
            </div>
            <div className="date-of-birth">
              <div class="form-group modal-form-cs lg:w-1/4 md:w-1/4 w-full lg:pr-3 md:pr-3 pr-0">
                <label for="">Address Type</label>
              </div>

              <div className="flex items-center">
                <div>
                  {/*                    
        <input type="radio"
               value="1"
               checked={this.state.AddressType == "1"}
               onChange={()=>this.setAddType(1)} />Permanent

        <input type="radio"
               value="2"
               checked={this.state.AddressType == "2"}
               onChange={()=>this.setAddType(2)}/>Current */}

                  <input
                    id="radio-1"
                    class="radio-custom"
                    name="radio-group"
                    type="radio"
                    value="1"
                    checked={this.state.AddressType == "1"}
                    onChange={() => this.setAddType(1)}
                  />
                  <label
                    for="radio-1"
                    class="radio-custom-label fsize16 text-black font-normal"
                  >
                    Permanent
                  </label>
                </div>
                {this.state.isPresentVisible ? (
                  <div className="ml-6">
                    <input
                      id="radio-2"
                      class="radio-custom"
                      name="radio-group"
                      type="radio"
                      value="2"
                      checked={this.state.AddressType == "2"}
                      onChange={() => this.setAddType(2)}
                    />
                    <label
                      for="radio-2"
                      class="radio-custom-label fsize16 text-black font-normal"
                    >
                      Current
                    </label>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            {this.state.AddressType == 1 ? (
              <div>
                <div className="flex items-center md:mt-4 lg:mt-4 mt-3 px-2 ">
                  {/* <input type="checkbox" className="w-18px h-18px " /> */}
                  <label class="custcheckbox">
                    <p className="text-black fsize16  ml-2">
                      Current same as permanent Address
                    </p>
                    <input
                      type="checkbox"
                      onChange={() =>
                        this.setState({
                          sameasPermanent: !this.state.sameasPermanent,
                          isPresentVisible: !this.state.isPresentVisible,
                        })
                      }
                    />
                    <span class="overhide-span top-5px"></span>
                  </label>
                </div>
                <div className="lg:flex md:flex  items-center mt-2 ">
                  <div class="form-group pt-4 modal-form-cs  lg:w-1/4 md:w-1/4  w-full lg:pr-6 md:pr-6">
                    <label for="">
                      Country <span className="text-red">*</span>
                    </label>
                    <Select
                      options={this.state.OptionsCountry}
                      className="select-dropdown-c fsize15 select-search-ht"
                      value={this.state.selectedCountryPermanentValue}
                      // defaultValue={this.state.selectedCountryPermanent}
                      onChange={(e) => this.handleChangeCountry(e)}
                    ></Select>
                    {/* {this.state.show ? (
                      <>
                        <label id="otherName">
                          Enter your Name
                          <input type="text" name="othername" />
                        </label>
                      </>
                    ):""} */}
                  </div>
                  <div class="form-group pt-4 modal-form-cs  lg:w-1/4 md:w-1/4  w-full lg:pr-6 md:pr-6">
                    <label for="">
                      State <span className="text-red">*</span>
                    </label>
                    <Select
                      options={this.state.OptionsState}
                      className="select-dropdown-c fsize15 select-search-ht"
                      value={this.state.selectedStatePermanentValue}
                      onChange={(e) => this.handleChangeState(e)}
                    >
                      {/* <option value="0" disabled>
                        Select
                      </option>
                      {this.props.STATEMASTER
                        ? this.props.STATEMASTER.Data
                          ? this.props.STATEMASTER.Data.map((x) => {
                              return <option value={x.Value}>{x.Title}</option>;
                            })
                          : ""
                        : ""} */}
                    </Select>
                  </div>
                  <div class="form-group pt-4 modal-form-cs  lg:w-1/4 md:w-1/4  w-full lg:pr-6 md:pr-6">
                    <label for="">
                      City <span className="text-red">*</span>
                    </label>
                    <Select
                      options={this.state.OptionsCity}
                      className="select-dropdown-c fsize15 select-search-ht"
                      value={this.state.selectedCityPermanentValue}
                      onChange={(e) => this.handleChangeCity(e)}
                    >
                      {/* <option value="" disabled>
                        Select
                      </option> */}
                      {/* {this.props.CITYMASTER
                        ? this.props.CITYMASTER.Data
                          ? this.props.CITYMASTER.Data.map((x) => {
                              return <option value={x.Value}>{x.Title}</option>;
                            })
                          : ""
                        : ""} */}
                    </Select>
                  </div>
                  <div class="form-group pt-4 modal-form-cs lg:w-1/4 md:w-1/4 w-full md:pr-6 lg:pr-6">
                    <label for="">
                      Pin Code <span className="text-red">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className=" fsize15"
                      value={this.state.PincodePermanent}
                      maxLength="6"
                      onChange={(e) =>
                        this.setState({
                          PincodePermanent: e.target.value.replace(
                            /[^\d]/g,
                            ""
                          ),
                        })
                      }
                    />
                  </div>
                </div>

                <div className="lg:flex md:flex items-center mt-4">
                  <div class="form-group  modal-form-cs  lg:pr-6 md:pr-6 lg:w-1/2 md:w-1/2 ">
                    <label for="">
                      Address Line 1 <span className="text-red">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className="h-79px pb-12 fsize16 "
                      value={this.state.Add1Permanent}
                      onChange={(e) =>
                        this.setState({ Add1Permanent: e.target.value })
                      }
                    />
                  </div>

                  <div class="form-group  modal-form-cs  lg:pr-6 md:pr-6 lg:w-1/2 md:w-1/2">
                    <label for="">Address Line 2 (optional)</label>
                    <input
                      type="text"
                      placeholder=""
                      className="h-79px pb-12 fsize16"
                      value={this.state.Add2Permanent}
                      onChange={(e) =>
                        this.setState({ Add2Permanent: e.target.value })
                      }
                    />
                  </div>
                </div>
                {/* <div class="form-group pt-4 modal-form-cs lg:w-1/2 md:w-1/2 w-full lg:pr-4 md:pr-4">
                  <label for="">
                    How long have you been staying here (months)
                  </label>
                  <select className="select-dropdown-c fsize15">
                    <option value="" disabled>
                      1 Month
                    </option>
                  </select>
                </div> */}
              </div>
            ) : (
              //  present
              <div>
                <div className="lg:flex md:flex  items-center mt-2  w-full">
                  <div class="form-group pt-4 modal-form-cs  lg:w-1/4 md:w-1/4  w-full lg:pr-6 md:pr-6">
                    <label for="">
                      Country <span className="text-red">*</span>
                    </label>
                    <Select
                      options={this.state.OptionsPrsentCountry}
                      className="select-dropdown-c fsize15 select-search-ht"
                      value={this.state.selectedCountryPresentValue}
                      // defaultValue={this.state.selectedCountryPermanent}
                      onChange={(e) => this.handleChangeCountryPresent(e)}
                    ></Select>
                  </div>
                  <div class="form-group pt-4 modal-form-cs  lg:w-1/4 md:w-1/4  w-full lg:pr-6 md:pr-6">
                    <label for="">
                      State <span className="text-red">*</span>
                    </label>
                    <Select
                      options={this.state.OptionsPrsentState}
                      className="select-dropdown-c fsize15 select-search-ht"
                      value={this.state.selectedStatePresentValue}
                      onChange={(e) => this.handleChangeStatePresent(e)}
                    ></Select>
                  </div>
                  <div class="form-group pt-4 modal-form-cs  lg:w-1/4 md:w-1/4  w-full lg:pr-6 md:pr-6">
                    <label for="">
                      City <span className="text-red">*</span>
                    </label>
                    <Select
                      options={this.state.OptionsPrsentCity}
                      className="select-dropdown-c fsize15 select-search-ht"
                      value={this.state.selectedCityPresentValue}
                      onChange={(e) => this.handleChangeCityPresent(e)}
                    ></Select>
                  </div>
                  <div class="form-group pt-4 modal-form-cs lg:w-1/4 md:w-1/4 lg:pr-4 md:pr-4 w-full ">
                    <label for="">
                      Pin Code <span className="text-red">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className=" fsize15"
                      maxLength={6}
                      value={this.state.PincodePresent}
                      onChange={(e) =>
                        this.setState({
                          PincodePresent: e.target.value.replace(/[^\d]/g, ""),
                        })
                      }
                    />
                  </div>
                </div>

                <div className="lg:flex md:flex items-center mt-4  w-full">
                  <div class="form-group  modal-form-cs  lg:pr-6 md:pr-6 lg:w-1/2 md:w-1/2">
                    <label for="">
                      Address Line 1 <span className="text-red">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className="h-79px pb-12 fsize16"
                      value={this.state.Add1Present}
                      onChange={(e) =>
                        this.setState({ Add1Present: e.target.value })
                      }
                    />
                  </div>

                  <div class="form-group  modal-form-cs lg:pl-0.5 md:pl-0.5 lg:pt-0 lg:w-1/2 md:w-1/2 pr-4 ">
                    <label for="">Address Line 2 (optional)</label>
                    <input
                      type="text"
                      placeholder=""
                      className="h-79px pb-12 fsize16"
                      value={this.state.Add2Present}
                      onChange={(e) =>
                        this.setState({ Add2Present: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
            )}

            <div className=" flex justify-end w-full lg:mt-10 md:mt-10 mt-6 ">
              <button
                className="btn btn-filled mr-2 btn-width-sm"
                type="button"
                onClick={(e) => this.submitContactDetails(e)}
              >
                {this.state.Submited ? "Update" : "Save"}
              </button>
            </div>

            {/*
            <div className="w-3/4">
              <div class="form-group pt-4 modal-form-cs w-1/2 pr-2">
                <label for="">
                  how long Have you been staying here (months)
                </label>
                <select className="select-dropdown-c fsize16">
                  <option value="Male">1 Month</option>
                  <option value="Female">2 Month</option>
                </select>
              </div>
            </div> */}
          </div>
        </div>
      </card>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    Profile: state.Profile.home.SINGLEAPPLICANTINFO,
    CONTACTDETAILS: state.userWalkthrough.info.CONTACTDETAILS,
    COUNTRYMASTER: state.master.info.COUNTRYMASTER,
    STATEMASTER: state.master.info.STATEMASTER,
    CITYMASTER: state.master.info.CITYMASTER,
    PARSERESUME: state.Profile.home.PARSERESUME
      ? state.Profile.home.PARSERESUME.Data.Document
      : "",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // getSingleApplicantInfoAction: async (payload) => {await dispatch(getSingleApplicantInfoAction(payload))},
    getCOUNTRYMASTERAction: async (payload) =>
      await dispatch(getCOUNTRYMASTERAction(payload)),
    getSTATEMASTERAction: async (payload) =>
      await dispatch(getSTATEMASTERAction(payload)),
    getCITYMASTERAction: async (payload) =>
      await dispatch(getCITYMASTERAction(payload)),
    setContactAction: async (payload) =>
      await dispatch(setContactAction(payload)),
    // getlanguageAction: async (payload) => await dispatch(getlanguageAction(payload))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Contact);
